module.exports = __webpack_public_path__ + "img/ParkingAreaPtownMaps2014_2.052aabf5.png";